import { render } from "./GitHubRepoLink.vue?vue&type=template&id=39543e6f&scoped=true"
import script from "./GitHubRepoLink.vue?vue&type=script&lang=js"
export * from "./GitHubRepoLink.vue?vue&type=script&lang=js"

import "./GitHubRepoLink.vue?vue&type=style&index=0&id=39543e6f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39543e6f"]])

export default __exports__